import { Card, Container, Row, Col, Image } from "react-bootstrap";
import Anohana from "../assets/images/newanime/anohana.png";
import Fate from "../assets/images/newanime/fate.jpeg";
import Jojos from "../assets/images/newanime/jojos.png";
import Fullmetal from "../assets/images/newanime/fullmetal.png";
import Tokyo from "../assets/images/newanime/tokyo.png";
import TokyoRevenger from "../assets/images/newanime/tokyorevenger.jpeg";
import Cowboy from "../assets/images/newanime/cowboybebop.jpeg";
import Conan from "../assets/images/newanime/conan.png";
import Stein from "../assets/images/newanime/stein.png";

const Superhero = () => {
  return (
    <div>
      <Container>
        <h1 className="text-center pt-5 pb-3 text-yellow">ANIME COMMON</h1>
        <Row>
          <Col md={4} className="movieWrapper" id="Superhero">
            <Card className="text-white bg-dark movieImage">
              <Image src={Anohana} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Anohana</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Fullmetal} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Fullmetal</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Fate} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Fate</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Jojos} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Jojos</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Tokyo} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Tokyo</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Stein} alt="Dune Movies" className="images" />
              <Card.Title className=" text-center mt-2">Stein</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image
                src={TokyoRevenger}
                alt="Tokyo Revenger"
                className="images"
              />
              <Card.Title className=" text-center mt-2">
                Tokyo Revenger
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Conan} alt="Conan" className="images" />
              <Card.Title className=" text-center mt-2">Conan</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Cowboy} alt="Coybow" className="images" />
              <Card.Title className=" text-center mt-2">Cowboy</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Superhero;
